import { createWebSocketStore } from 'src/components/#services/helpers';
export const getArticlesByFilter = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'blog_getAllByFilter',
    },
});
export const getCategoriesWithArticles = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'blog_getAllWithCategoryList',
    },
});
export const getPinnedArticle = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'blog_getPinned',
    },
});
export const getArticleByUrl = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'blog_getByUrl',
    },
});
